"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const form_toggle_module_scss_1 = __importDefault(require("./form-toggle.module.scss"));
const FormToggle = ({ children, className, isSelected, selectedClassName, dataSelectorPrefix = 'toggle', ...props }) => {
    const toggleClassName = (0, classnames_1.default)(form_toggle_module_scss_1.default.formToggle, className, {
        [`${selectedClassName || form_toggle_module_scss_1.default.isSelected}`]: isSelected,
        [form_toggle_module_scss_1.default.outOfStock]: props.isOutOfStock
    });
    const dataSelector = `${dataSelectorPrefix}-${children}`;
    return ((0, jsx_runtime_1.jsx)("div", { "data-selector": dataSelector, type: "button", "aria-pressed": isSelected, className: toggleClassName, ...props, children: children }));
};
FormToggle.propTypes = {
    children: prop_types_1.default.node.isRequired,
    className: prop_types_1.default.string,
    isSelected: prop_types_1.default.bool,
    selectedClassName: prop_types_1.default.string,
    dataSelectorPrefix: prop_types_1.default.string
};
exports.default = FormToggle;
//# sourceMappingURL=form-toggle.js.map